import { render, staticRenderFns } from "./ApplyCourse.vue?vue&type=template&id=6ea67a96&scoped=true"
import script from "./ApplyCourse.vue?vue&type=script&lang=js"
export * from "./ApplyCourse.vue?vue&type=script&lang=js"
import style0 from "./ApplyCourse.vue?vue&type=style&index=0&id=6ea67a96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea67a96",
  null
  
)

export default component.exports